import { Component, inject, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationBarComponent } from '@lyceo/homi-dashboard/shared/ui';
import { NavigationItem } from '@lyceo/homi-dashboard/shared/util-models';
import { UserFacade } from '@lyceo/homi-dashboard/user/data-access';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'lyceo-homi-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [RouterModule, NavigationBarComponent, IonRouterOutlet],
})
export class DashboardComponent {
  private readonly userFacade: UserFacade = inject(UserFacade);
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  public userFullName: Signal<string | undefined> =
    this.authFacade.userFullName;

  public navItems: Signal<NavigationItem[]> = this.userFacade.userMenuItems;

  public logout(): void {
    this.authFacade.userLogout();
  }
}
